export const Swatches = {
    Blue1: '#eff5f9',
    Blue2: '#deedf7',
    Blue3: '#afd2f3',
    Blue4: '#72a7ed',
    Blue5: '#417de8',
    Blue6: '#2e6be6',
    Blue7: '#2e64d2',
    Blue8: '#2d55ad',
    Blue9: '#284484',
    Blue10: '#213462',
    Blue11: '#1d2c52',
    Orange1: '#fcf5ee',
    Orange2: '#fbeddf',
    Orange3: '#fad6b8',
    Orange4: '#f8b283',
    Orange5: '#f68c53',
    Orange6: '#f57a3d',
    Orange7: '#e16f3e',
    Orange8: '#b5583d',
    Orange9: '#834035',
    Orange10: '#572c29',
    Orange11: '#432221',
    Green1: '#eef8f1',
    Green2: '#dcf1e3',
    Green3: '#adddc0',
    Green4: '#75c29d',
    Green5: '#4aa985',
    Green6: '#399e7c',
    Green7: '#359379',
    Green8: '#2d7a6f',
    Green9: '#235e5f',
    Green10: '#1a4146',
    Green11: '#16343b',
    White: '#ffffff',
    Black: '#000000',
    Red1: '#fff0f0',
    Red2: '#fee3e3',
    Red3: '#fbc0c1',
    Red4: '#f79295',
    Red5: '#f3676f',
    Red6: '#f1555f',
    Red7: '#dd4f5e',
    Red8: '#b24258',
    Red9: '#803149',
    Red10: '#552236',
    Red11: '#411a2b',
    Gray1: '#fafbfc',
    Gray2: '#f0f3f6',
    Gray3: '#dae0e7',
    Gray4: '#b9c4d0',
    Gray5: '#92a1b3',
    Gray6: '#6d7e94',
    Gray7: '#4f5f76',
    Gray8: '#3b495f',
    Gray9: '#2c384c',
    Gray10: '#1f2a3c',
    Gray11: '#151d2b',
    Transparent: '#7f7f7f00',
    AlphaLightGray0: '#fafbfc00',
    AlphaLightGray10: '#fafbfc1a',
    AlphaLightGray20: '#fafbfc33',
    AlphaLightGray30: '#fafbfc4d',
    AlphaLightGray40: '#fafbfc66',
    AlphaLightGray50: '#fafbfc80',
    AlphaLightGray60: '#fafbfc99',
    AlphaLightGray70: '#fafbfcb3',
    AlphaLightGray80: '#fafbfccc',
    AlphaLightGray90: '#fafbfce6',
    AlphaLightGray100: '#fafbfc',
    AlphaDarkGray0: '#151d2b00',
    AlphaDarkGray10: '#151d2b1a',
    AlphaDarkGray20: '#151d2b33',
    AlphaDarkGray30: '#151d2b4d',
    AlphaDarkGray40: '#151d2b66',
    AlphaDarkGray50: '#151d2b80',
    AlphaDarkGray60: '#151d2b99',
    AlphaDarkGray70: '#151d2bb3',
    AlphaDarkGray80: '#151d2bcc',
    AlphaDarkGray90: '#151d2be6',
    AlphaDarkGray100: '#151d2b',
    AlphaMiddleGray0: '#6d7e9400',
    AlphaMiddleGray10: '#6d7e941a',
    AlphaMiddleGray20: '#6d7e9433',
    AlphaMiddleGray30: '#6d7e944d',
    AlphaMiddleGray40: '#6d7e9466',
    AlphaMiddleGray50: '#6d7e9480',
    AlphaMiddleGray60: '#6d7e9499',
    AlphaMiddleGray70: '#6d7e94b3',
    AlphaMiddleGray80: '#6d7e94cc',
    AlphaMiddleGray90: '#6d7e94e6',
    AlphaMiddleGray100: '#6d7e94',
    AlphaMiddleBlue0: '#2e6be600',
    AlphaMiddleBlue10: '#2e6be61a',
    AlphaMiddleBlue20: '#2e6be633',
    AlphaMiddleBlue30: '#2e6be64d',
    AlphaMiddleBlue40: '#2e6be666',
    AlphaMiddleBlue50: '#2e6be680',
    AlphaMiddleBlue60: '#2e6be699',
    AlphaMiddleBlue70: '#2e6be6b3',
    AlphaMiddleBlue80: '#2e6be6cc',
    AlphaMiddleBlue90: '#2e6be6e6',
    AlphaMiddleBlue100: '#2e6be6',
    AlphaMiddleOrange0: '#f57a3d00',
    AlphaMiddleOrange10: '#f57a3d1a',
    AlphaMiddleOrange20: '#f57a3d33',
    AlphaMiddleOrange30: '#f57a3d4d',
    AlphaMiddleOrange40: '#f57a3d66',
    AlphaMiddleOrange50: '#f57a3d80',
    AlphaMiddleOrange60: '#f57a3d99',
    AlphaMiddleOrange70: '#f57a3db3',
    AlphaMiddleOrange80: '#f57a3dcc',
    AlphaMiddleOrange90: '#f57a3de6',
    AlphaMiddleOrange100: '#f57a3d',
    AlphaMiddleGreen0: '#399e7c00',
    AlphaMiddleGreen10: '#399e7c1a',
    AlphaMiddleGreen20: '#399e7c33',
    AlphaMiddleGreen30: '#399e7c4d',
    AlphaMiddleGreen40: '#399e7c66',
    AlphaMiddleGreen50: '#399e7c80',
    AlphaMiddleGreen60: '#399e7c99',
    AlphaMiddleGreen70: '#399e7cb3',
    AlphaMiddleGreen80: '#399e7ccc',
    AlphaMiddleGreen90: '#399e7ce6',
    AlphaMiddleGreen100: '#399e7c',
    AlphaMiddleRed0: '#f1555f00',
    AlphaMiddleRed10: '#f1555f1a',
    AlphaMiddleRed20: '#f1555f33',
    AlphaMiddleRed30: '#f1555f4d',
    AlphaMiddleRed40: '#f1555f66',
    AlphaMiddleRed50: '#f1555f80',
    AlphaMiddleRed60: '#f1555f99',
    AlphaMiddleRed70: '#f1555fb3',
    AlphaMiddleRed80: '#f1555fcc',
    AlphaMiddleRed90: '#f1555fe6',
    AlphaMiddleRed100: '#f1555f',
} as const;

export const ThemeLight = {
    Background1: Swatches.Gray2,
    Background2: Swatches.Gray1,
    Background3: Swatches.White,
    BackgroundB1: Swatches.Gray3,
    Border1: Swatches.Gray3,
    Border2: Swatches.Gray3,
    Border3: Swatches.Gray3,
    BorderB1: Swatches.Gray4,
    PrimaryInverted1: Swatches.Blue11,
    PrimaryInverted2: Swatches.Blue10,
    PrimaryInverted3: Swatches.Blue9,
    PrimaryInverted4: Swatches.Blue8,
    PrimaryInverted5: Swatches.Blue7,
    PrimaryInverted6: Swatches.Blue6,
    PrimaryInverted7: Swatches.Blue5,
    PrimaryInverted8: Swatches.Blue4,
    PrimaryInverted9: Swatches.Blue3,
    PrimaryInverted10: Swatches.Blue2,
    PrimaryInverted11: Swatches.Blue1,
    PrimaryConstant1: Swatches.Blue11,
    PrimaryConstant6: Swatches.Blue6,
    PrimaryConstant11: Swatches.Blue1,
    PrimaryTranslated1: Swatches.Blue1,
    PrimaryTranslated2: Swatches.Blue2,
    PrimaryTranslated3: Swatches.Blue3,
    PrimaryTranslated4: Swatches.Blue4,
    PrimaryTranslated5: Swatches.Blue5,
    PrimaryOpacity1: Swatches.AlphaMiddleBlue0,
    PrimaryOpacity2: Swatches.AlphaMiddleBlue10,
    PrimaryOpacity3: Swatches.AlphaMiddleBlue20,
    PrimaryOpacity4: Swatches.AlphaMiddleBlue30,
    PrimaryOpacity5: Swatches.AlphaMiddleBlue40,
    PrimaryOpacity6: Swatches.AlphaMiddleBlue50,
    PrimaryOpacity7: Swatches.AlphaMiddleBlue60,
    PrimaryOpacity8: Swatches.AlphaMiddleBlue70,
    PrimaryOpacity9: Swatches.AlphaMiddleBlue80,
    PrimaryOpacity10: Swatches.AlphaMiddleBlue90,
    PrimaryOpacity11: Swatches.AlphaMiddleBlue100,
    PrimaryMild1: Swatches.Blue3,
    PrimaryMild2: Swatches.Blue2,
    PrimaryMild3: Swatches.Blue2,
    PrimaryMildB1: Swatches.Blue3,
    PrimaryMedium1: Swatches.Blue4,
    PrimaryMedium2: Swatches.Blue3,
    PrimaryMedium3: Swatches.Blue3,
    PrimaryMediumB1: Swatches.Blue4,
    SuccessInverted1: Swatches.Green11,
    SuccessInverted2: Swatches.Green10,
    SuccessInverted3: Swatches.Green9,
    SuccessInverted4: Swatches.Green8,
    SuccessInverted5: Swatches.Green7,
    SuccessInverted6: Swatches.Green6,
    SuccessInverted7: Swatches.Green5,
    SuccessInverted8: Swatches.Green4,
    SuccessInverted9: Swatches.Green3,
    SuccessInverted10: Swatches.Green2,
    SuccessInverted11: Swatches.Green1,
    SuccessConstant1: Swatches.Green11,
    SuccessConstant6: Swatches.Green6,
    SuccessConstant11: Swatches.Green1,
    SuccessTranslated1: Swatches.Green1,
    SuccessTranslated2: Swatches.Green2,
    SuccessTranslated3: Swatches.Green3,
    SuccessTranslated4: Swatches.Green4,
    SuccessTranslated5: Swatches.Green5,
    SuccessOpacity1: Swatches.AlphaMiddleGreen0,
    SuccessOpacity2: Swatches.AlphaMiddleGreen10,
    SuccessOpacity3: Swatches.AlphaMiddleGreen20,
    SuccessOpacity4: Swatches.AlphaMiddleGreen30,
    SuccessOpacity5: Swatches.AlphaMiddleGreen40,
    SuccessOpacity6: Swatches.AlphaMiddleGreen50,
    SuccessOpacity7: Swatches.AlphaMiddleGreen60,
    SuccessOpacity8: Swatches.AlphaMiddleGreen70,
    SuccessOpacity9: Swatches.AlphaMiddleGreen80,
    SuccessOpacity10: Swatches.AlphaMiddleGreen90,
    SuccessOpacity11: Swatches.AlphaMiddleGreen100,
    SuccessMedium1: Swatches.Green4,
    SuccessMedium2: Swatches.Green3,
    SuccessMedium3: Swatches.Green3,
    SuccessMediumB1: Swatches.Green4,
    SuccessMild1: Swatches.Green3,
    SuccessMild2: Swatches.Green2,
    SuccessMild3: Swatches.Green2,
    SuccessMildB1: Swatches.Green3,
    AttentionInverted1: Swatches.Orange11,
    AttentionInverted2: Swatches.Orange10,
    AttentionInverted3: Swatches.Orange9,
    AttentionInverted4: Swatches.Orange8,
    AttentionInverted5: Swatches.Orange7,
    AttentionInverted6: Swatches.Orange6,
    AttentionInverted7: Swatches.Orange5,
    AttentionInverted8: Swatches.Orange4,
    AttentionInverted9: Swatches.Orange3,
    AttentionInverted10: Swatches.Orange2,
    AttentionInverted11: Swatches.Orange1,
    AttentionConstant1: Swatches.Orange11,
    AttentionConstant6: Swatches.Orange6,
    AttentionConstant11: Swatches.Orange1,
    AttentionTranslated1: Swatches.Orange1,
    AttentionTranslated2: Swatches.Orange2,
    AttentionTranslated3: Swatches.Orange3,
    AttentionTranslated4: Swatches.Orange4,
    AttentionTranslated5: Swatches.Orange5,
    AttentionOpacity1: Swatches.AlphaMiddleOrange0,
    AttentionOpacity2: Swatches.AlphaMiddleOrange10,
    AttentionOpacity3: Swatches.AlphaMiddleOrange20,
    AttentionOpacity4: Swatches.AlphaMiddleOrange30,
    AttentionOpacity5: Swatches.AlphaMiddleOrange40,
    AttentionOpacity6: Swatches.AlphaMiddleOrange50,
    AttentionOpacity7: Swatches.AlphaMiddleOrange60,
    AttentionOpacity8: Swatches.AlphaMiddleOrange70,
    AttentionOpacity9: Swatches.AlphaMiddleOrange80,
    AttentionOpacity10: Swatches.AlphaMiddleOrange90,
    AttentionOpacity11: Swatches.AlphaMiddleOrange100,
    AttentionMild1: Swatches.Orange3,
    AttentionMild2: Swatches.Orange3,
    AttentionMild3: Swatches.Orange2,
    AttentionMildB1: Swatches.Orange4,
    AttentionMedium1: Swatches.Orange4,
    AttentionMedium2: Swatches.Orange4,
    AttentionMedium3: Swatches.Orange3,
    AttentionMediumB1: Swatches.Orange5,
    WarningInverted1: Swatches.Red11,
    WarningInverted2: Swatches.Red10,
    WarningInverted3: Swatches.Red9,
    WarningInverted4: Swatches.Red8,
    WarningInverted5: Swatches.Red7,
    WarningInverted6: Swatches.Red6,
    WarningInverted7: Swatches.Red5,
    WarningInverted8: Swatches.Red4,
    WarningInverted9: Swatches.Red3,
    WarningInverted10: Swatches.Red2,
    WarningInverted11: Swatches.Red1,
    WarningConstant1: Swatches.Red11,
    WarningConstant6: Swatches.Red6,
    WarningConstant11: Swatches.Red1,
    WarningTranslated1: Swatches.Red1,
    WarningTranslated2: Swatches.Red2,
    WarningTranslated3: Swatches.Red3,
    WarningTranslated4: Swatches.Red4,
    WarningTranslated5: Swatches.Red5,
    WarningOpacity1: Swatches.AlphaMiddleRed0,
    WarningOpacity2: Swatches.AlphaMiddleRed10,
    WarningOpacity3: Swatches.AlphaMiddleRed20,
    WarningOpacity4: Swatches.AlphaMiddleRed30,
    WarningOpacity5: Swatches.AlphaMiddleRed40,
    WarningOpacity6: Swatches.AlphaMiddleRed50,
    WarningOpacity7: Swatches.AlphaMiddleRed60,
    WarningOpacity8: Swatches.AlphaMiddleRed70,
    WarningOpacity9: Swatches.AlphaMiddleRed80,
    WarningOpacity10: Swatches.AlphaMiddleRed90,
    WarningOpacity11: Swatches.AlphaMiddleRed100,
    WarningMild1: Swatches.Red3,
    WarningMild2: Swatches.Red2,
    WarningMild3: Swatches.Red2,
    WarningMildB1: Swatches.Red3,
    WarningMedium1: Swatches.Red4,
    WarningMedium2: Swatches.Red3,
    WarningMedium3: Swatches.Red3,
    WarningMediumB1: Swatches.Red4,
    NeutralConstant1: Swatches.Gray11,
    NeutralConstant6: Swatches.Gray6,
    NeutralConstant11: Swatches.Gray1,
    NeutralInverted1: Swatches.Gray11,
    NeutralInverted2: Swatches.Gray10,
    NeutralInverted3: Swatches.Gray9,
    NeutralInverted4: Swatches.Gray8,
    NeutralInverted5: Swatches.Gray7,
    NeutralInverted6: Swatches.Gray6,
    NeutralInverted7: Swatches.Gray5,
    NeutralInverted8: Swatches.Gray4,
    NeutralInverted9: Swatches.Gray3,
    NeutralInverted10: Swatches.Gray2,
    NeutralInverted11: Swatches.Gray1,
    NeutralTranslated1: Swatches.Gray1,
    NeutralTranslated2: Swatches.Gray2,
    NeutralTranslated3: Swatches.Gray3,
    NeutralTranslated4: Swatches.Gray4,
    NeutralTranslated5: Swatches.Gray5,
    NeutralOpacity1: Swatches.AlphaMiddleGray0,
    NeutralOpacity2: Swatches.AlphaMiddleGray10,
    NeutralOpacity3: Swatches.AlphaMiddleGray20,
    NeutralOpacity4: Swatches.AlphaMiddleGray30,
    NeutralOpacity5: Swatches.AlphaMiddleGray40,
    NeutralOpacity6: Swatches.AlphaMiddleGray50,
    NeutralOpacity7: Swatches.AlphaMiddleGray60,
    NeutralOpacity8: Swatches.AlphaMiddleGray70,
    NeutralOpacity9: Swatches.AlphaMiddleGray80,
    NeutralOpacity10: Swatches.AlphaMiddleGray90,
    NeutralOpacity11: Swatches.AlphaMiddleGray100,
    NeutralMild1: Swatches.Gray3,
    NeutralMild2: Swatches.Gray3,
    NeutralMild3: Swatches.Gray2,
    NeutralMildB1: Swatches.Gray4,
    NeutralMedium1: Swatches.Gray4,
    NeutralMedium2: Swatches.Gray4,
    NeutralMedium3: Swatches.Gray3,
    NeutralMediumB1: Swatches.Gray5,
    TextStrong: Swatches.Gray9,
    TextMedium: Swatches.Gray8,
    TextMild: Swatches.Gray7,
    TextXMild: Swatches.Gray5,
    OverlaySync1: Swatches.AlphaLightGray0,
    OverlaySync2: Swatches.AlphaLightGray10,
    OverlaySync3: Swatches.AlphaLightGray20,
    OverlaySync4: Swatches.AlphaLightGray30,
    OverlaySync5: Swatches.AlphaLightGray40,
    OverlaySync6: Swatches.AlphaLightGray50,
    OverlaySync7: Swatches.AlphaLightGray60,
    OverlaySync8: Swatches.AlphaLightGray70,
    OverlaySync9: Swatches.AlphaLightGray80,
    OverlaySync10: Swatches.AlphaLightGray90,
    OverlaySync11: Swatches.AlphaLightGray100,
    OverlayContrast1: Swatches.AlphaDarkGray0,
    OverlayContrast2: Swatches.AlphaDarkGray10,
    OverlayContrast3: Swatches.AlphaDarkGray20,
    OverlayContrast4: Swatches.AlphaDarkGray30,
    OverlayContrast5: Swatches.AlphaDarkGray40,
    OverlayContrast6: Swatches.AlphaDarkGray50,
    OverlayContrast7: Swatches.AlphaDarkGray60,
    OverlayContrast8: Swatches.AlphaDarkGray70,
    OverlayContrast9: Swatches.AlphaDarkGray80,
    OverlayContrast10: Swatches.AlphaDarkGray90,
    OverlayContrast11: Swatches.AlphaDarkGray100,
    OverlayLight1: Swatches.AlphaLightGray0,
    OverlayLight2: Swatches.AlphaLightGray10,
    OverlayLight3: Swatches.AlphaLightGray20,
    OverlayLight4: Swatches.AlphaLightGray30,
    OverlayLight5: Swatches.AlphaLightGray40,
    OverlayLight6: Swatches.AlphaLightGray50,
    OverlayLight7: Swatches.AlphaLightGray60,
    OverlayLight8: Swatches.AlphaLightGray70,
    OverlayLight9: Swatches.AlphaLightGray80,
    OverlayLight10: Swatches.AlphaLightGray90,
    OverlayLight11: Swatches.AlphaLightGray100,
    OverlayDark1: Swatches.AlphaDarkGray0,
    OverlayDark2: Swatches.AlphaDarkGray10,
    OverlayDark3: Swatches.AlphaDarkGray20,
    OverlayDark4: Swatches.AlphaDarkGray30,
    OverlayDark5: Swatches.AlphaDarkGray40,
    OverlayDark6: Swatches.AlphaDarkGray50,
    OverlayDark7: Swatches.AlphaDarkGray60,
    OverlayDark8: Swatches.AlphaDarkGray70,
    OverlayDark9: Swatches.AlphaDarkGray80,
    OverlayDark10: Swatches.AlphaDarkGray90,
    OverlayDark11: Swatches.AlphaDarkGray100,
} as const;

export const ThemeDark = {
    Background1: Swatches.Gray10,
    Background2: Swatches.Gray9,
    Background3: Swatches.Gray8,
    BackgroundB1: Swatches.Gray11,
    Border1: Swatches.Gray8,
    Border2: Swatches.Gray8,
    Border3: Swatches.Gray7,
    BorderB1: Swatches.Gray9,
    PrimaryInverted1: Swatches.Blue1,
    PrimaryInverted2: Swatches.Blue2,
    PrimaryInverted3: Swatches.Blue3,
    PrimaryInverted4: Swatches.Blue4,
    PrimaryInverted5: Swatches.Blue5,
    PrimaryInverted6: Swatches.Blue6,
    PrimaryInverted7: Swatches.Blue7,
    PrimaryInverted8: Swatches.Blue8,
    PrimaryInverted9: Swatches.Blue9,
    PrimaryInverted10: Swatches.Blue10,
    PrimaryInverted11: Swatches.Blue11,
    PrimaryConstant1: Swatches.Blue11,
    PrimaryConstant6: Swatches.Blue6,
    PrimaryConstant11: Swatches.Blue1,
    PrimaryTranslated1: Swatches.Blue7,
    PrimaryTranslated2: Swatches.Blue8,
    PrimaryTranslated3: Swatches.Blue9,
    PrimaryTranslated4: Swatches.Blue10,
    PrimaryTranslated5: Swatches.Blue11,
    PrimaryOpacity1: Swatches.AlphaMiddleBlue0,
    PrimaryOpacity2: Swatches.AlphaMiddleBlue10,
    PrimaryOpacity3: Swatches.AlphaMiddleBlue20,
    PrimaryOpacity4: Swatches.AlphaMiddleBlue30,
    PrimaryOpacity5: Swatches.AlphaMiddleBlue40,
    PrimaryOpacity6: Swatches.AlphaMiddleBlue50,
    PrimaryOpacity7: Swatches.AlphaMiddleBlue60,
    PrimaryOpacity8: Swatches.AlphaMiddleBlue70,
    PrimaryOpacity9: Swatches.AlphaMiddleBlue80,
    PrimaryOpacity10: Swatches.AlphaMiddleBlue90,
    PrimaryOpacity11: Swatches.AlphaMiddleBlue100,
    PrimaryMild1: Swatches.Blue9,
    PrimaryMild2: Swatches.Blue9,
    PrimaryMild3: Swatches.Blue8,
    PrimaryMildB1: Swatches.Blue10,
    PrimaryMedium1: Swatches.Blue8,
    PrimaryMedium2: Swatches.Blue8,
    PrimaryMedium3: Swatches.Blue7,
    PrimaryMediumB1: Swatches.Blue9,
    SuccessInverted1: Swatches.Green1,
    SuccessInverted2: Swatches.Green2,
    SuccessInverted3: Swatches.Green3,
    SuccessInverted4: Swatches.Green4,
    SuccessInverted5: Swatches.Green5,
    SuccessInverted6: Swatches.Green6,
    SuccessInverted7: Swatches.Green7,
    SuccessInverted8: Swatches.Green8,
    SuccessInverted9: Swatches.Green9,
    SuccessInverted10: Swatches.Green10,
    SuccessInverted11: Swatches.Green11,
    SuccessConstant1: Swatches.Green11,
    SuccessConstant6: Swatches.Green6,
    SuccessConstant11: Swatches.Green1,
    SuccessTranslated1: Swatches.Green7,
    SuccessTranslated2: Swatches.Green8,
    SuccessTranslated3: Swatches.Green9,
    SuccessTranslated4: Swatches.Green10,
    SuccessTranslated5: Swatches.Green11,
    SuccessOpacity1: Swatches.AlphaMiddleGreen0,
    SuccessOpacity2: Swatches.AlphaMiddleGreen10,
    SuccessOpacity3: Swatches.AlphaMiddleGreen20,
    SuccessOpacity4: Swatches.AlphaMiddleGreen30,
    SuccessOpacity5: Swatches.AlphaMiddleGreen40,
    SuccessOpacity6: Swatches.AlphaMiddleGreen50,
    SuccessOpacity7: Swatches.AlphaMiddleGreen60,
    SuccessOpacity8: Swatches.AlphaMiddleGreen70,
    SuccessOpacity9: Swatches.AlphaMiddleGreen80,
    SuccessOpacity10: Swatches.AlphaMiddleGreen90,
    SuccessOpacity11: Swatches.AlphaMiddleGreen100,
    SuccessMedium1: Swatches.Green8,
    SuccessMedium2: Swatches.Green8,
    SuccessMedium3: Swatches.Green7,
    SuccessMediumB1: Swatches.Green9,
    SuccessMild1: Swatches.Green9,
    SuccessMild2: Swatches.Green9,
    SuccessMild3: Swatches.Green8,
    SuccessMildB1: Swatches.Green10,
    AttentionInverted1: Swatches.Orange1,
    AttentionInverted2: Swatches.Orange2,
    AttentionInverted3: Swatches.Orange3,
    AttentionInverted4: Swatches.Orange4,
    AttentionInverted5: Swatches.Orange5,
    AttentionInverted6: Swatches.Orange6,
    AttentionInverted7: Swatches.Orange7,
    AttentionInverted8: Swatches.Orange8,
    AttentionInverted9: Swatches.Orange9,
    AttentionInverted10: Swatches.Orange10,
    AttentionInverted11: Swatches.Orange11,
    AttentionConstant1: Swatches.Orange11,
    AttentionConstant6: Swatches.Orange6,
    AttentionConstant11: Swatches.Orange1,
    AttentionTranslated1: Swatches.Orange7,
    AttentionTranslated2: Swatches.Orange8,
    AttentionTranslated3: Swatches.Orange9,
    AttentionTranslated4: Swatches.Orange10,
    AttentionTranslated5: Swatches.Orange11,
    AttentionOpacity1: Swatches.AlphaMiddleOrange0,
    AttentionOpacity2: Swatches.AlphaMiddleOrange10,
    AttentionOpacity3: Swatches.AlphaMiddleOrange20,
    AttentionOpacity4: Swatches.AlphaMiddleOrange30,
    AttentionOpacity5: Swatches.AlphaMiddleOrange40,
    AttentionOpacity6: Swatches.AlphaMiddleOrange50,
    AttentionOpacity7: Swatches.AlphaMiddleOrange60,
    AttentionOpacity8: Swatches.AlphaMiddleOrange70,
    AttentionOpacity9: Swatches.AlphaMiddleOrange80,
    AttentionOpacity10: Swatches.AlphaMiddleOrange90,
    AttentionOpacity11: Swatches.AlphaMiddleOrange100,
    AttentionMild1: Swatches.Orange9,
    AttentionMild2: Swatches.Orange9,
    AttentionMild3: Swatches.Orange8,
    AttentionMildB1: Swatches.Orange10,
    AttentionMedium1: Swatches.Orange8,
    AttentionMedium2: Swatches.Orange8,
    AttentionMedium3: Swatches.Orange7,
    AttentionMediumB1: Swatches.Orange9,
    WarningInverted1: Swatches.Red1,
    WarningInverted2: Swatches.Red2,
    WarningInverted3: Swatches.Red3,
    WarningInverted4: Swatches.Red4,
    WarningInverted5: Swatches.Red5,
    WarningInverted6: Swatches.Red6,
    WarningInverted7: Swatches.Red7,
    WarningInverted8: Swatches.Red8,
    WarningInverted9: Swatches.Red9,
    WarningInverted10: Swatches.Red10,
    WarningInverted11: Swatches.Red11,
    WarningConstant1: Swatches.Red11,
    WarningConstant6: Swatches.Red6,
    WarningConstant11: Swatches.Red1,
    WarningTranslated1: Swatches.Red7,
    WarningTranslated2: Swatches.Red8,
    WarningTranslated3: Swatches.Red9,
    WarningTranslated4: Swatches.Red10,
    WarningTranslated5: Swatches.Red11,
    WarningOpacity1: Swatches.AlphaMiddleRed0,
    WarningOpacity2: Swatches.AlphaMiddleRed10,
    WarningOpacity3: Swatches.AlphaMiddleRed20,
    WarningOpacity4: Swatches.AlphaMiddleRed30,
    WarningOpacity5: Swatches.AlphaMiddleRed40,
    WarningOpacity6: Swatches.AlphaMiddleRed50,
    WarningOpacity7: Swatches.AlphaMiddleRed60,
    WarningOpacity8: Swatches.AlphaMiddleRed70,
    WarningOpacity9: Swatches.AlphaMiddleRed80,
    WarningOpacity10: Swatches.AlphaMiddleRed90,
    WarningOpacity11: Swatches.AlphaMiddleRed100,
    WarningMild1: Swatches.Red9,
    WarningMild2: Swatches.Red9,
    WarningMild3: Swatches.Red8,
    WarningMildB1: Swatches.Red10,
    WarningMedium1: Swatches.Red8,
    WarningMedium2: Swatches.Red8,
    WarningMedium3: Swatches.Red7,
    WarningMediumB1: Swatches.Red9,
    NeutralConstant1: Swatches.Gray11,
    NeutralConstant6: Swatches.Gray6,
    NeutralConstant11: Swatches.Gray1,
    NeutralInverted1: Swatches.Gray1,
    NeutralInverted2: Swatches.Gray2,
    NeutralInverted3: Swatches.Gray3,
    NeutralInverted4: Swatches.Gray4,
    NeutralInverted5: Swatches.Gray5,
    NeutralInverted6: Swatches.Gray6,
    NeutralInverted7: Swatches.Gray7,
    NeutralInverted8: Swatches.Gray8,
    NeutralInverted9: Swatches.Gray9,
    NeutralInverted10: Swatches.Gray10,
    NeutralInverted11: Swatches.Gray11,
    NeutralTranslated1: Swatches.Gray7,
    NeutralTranslated2: Swatches.Gray8,
    NeutralTranslated3: Swatches.Gray9,
    NeutralTranslated4: Swatches.Gray10,
    NeutralTranslated5: Swatches.Gray11,
    NeutralOpacity1: Swatches.AlphaMiddleGray0,
    NeutralOpacity2: Swatches.AlphaMiddleGray10,
    NeutralOpacity3: Swatches.AlphaMiddleGray20,
    NeutralOpacity4: Swatches.AlphaMiddleGray30,
    NeutralOpacity5: Swatches.AlphaMiddleGray40,
    NeutralOpacity6: Swatches.AlphaMiddleGray50,
    NeutralOpacity7: Swatches.AlphaMiddleGray60,
    NeutralOpacity8: Swatches.AlphaMiddleGray70,
    NeutralOpacity9: Swatches.AlphaMiddleGray80,
    NeutralOpacity10: Swatches.AlphaMiddleGray90,
    NeutralOpacity11: Swatches.AlphaMiddleGray100,
    NeutralMild1: Swatches.Gray9,
    NeutralMild2: Swatches.Gray8,
    NeutralMild3: Swatches.Gray7,
    NeutralMildB1: Swatches.Gray10,
    NeutralMedium1: Swatches.Gray8,
    NeutralMedium2: Swatches.Gray7,
    NeutralMedium3: Swatches.Gray6,
    NeutralMediumB1: Swatches.Gray9,
    TextStrong: Swatches.Gray3,
    TextMedium: Swatches.Gray4,
    TextMild: Swatches.Gray5,
    TextXMild: Swatches.Gray6,
    OverlaySync1: Swatches.AlphaDarkGray0,
    OverlaySync2: Swatches.AlphaDarkGray10,
    OverlaySync3: Swatches.AlphaDarkGray20,
    OverlaySync4: Swatches.AlphaDarkGray30,
    OverlaySync5: Swatches.AlphaDarkGray40,
    OverlaySync6: Swatches.AlphaDarkGray50,
    OverlaySync7: Swatches.AlphaDarkGray60,
    OverlaySync8: Swatches.AlphaDarkGray70,
    OverlaySync9: Swatches.AlphaDarkGray80,
    OverlaySync10: Swatches.AlphaDarkGray90,
    OverlaySync11: Swatches.AlphaDarkGray100,
    OverlayContrast1: Swatches.AlphaLightGray0,
    OverlayContrast2: Swatches.AlphaLightGray10,
    OverlayContrast3: Swatches.AlphaLightGray20,
    OverlayContrast4: Swatches.AlphaLightGray30,
    OverlayContrast5: Swatches.AlphaLightGray40,
    OverlayContrast6: Swatches.AlphaLightGray50,
    OverlayContrast7: Swatches.AlphaLightGray60,
    OverlayContrast8: Swatches.AlphaLightGray70,
    OverlayContrast9: Swatches.AlphaLightGray80,
    OverlayContrast10: Swatches.AlphaLightGray90,
    OverlayContrast11: Swatches.AlphaLightGray100,
    OverlayLight1: Swatches.AlphaLightGray0,
    OverlayLight2: Swatches.AlphaLightGray10,
    OverlayLight3: Swatches.AlphaLightGray20,
    OverlayLight4: Swatches.AlphaLightGray30,
    OverlayLight5: Swatches.AlphaLightGray40,
    OverlayLight6: Swatches.AlphaLightGray50,
    OverlayLight7: Swatches.AlphaLightGray60,
    OverlayLight8: Swatches.AlphaLightGray70,
    OverlayLight9: Swatches.AlphaLightGray80,
    OverlayLight10: Swatches.AlphaLightGray90,
    OverlayLight11: Swatches.AlphaLightGray100,
    OverlayDark1: Swatches.AlphaDarkGray0,
    OverlayDark2: Swatches.AlphaDarkGray10,
    OverlayDark3: Swatches.AlphaDarkGray20,
    OverlayDark4: Swatches.AlphaDarkGray30,
    OverlayDark5: Swatches.AlphaDarkGray40,
    OverlayDark6: Swatches.AlphaDarkGray50,
    OverlayDark7: Swatches.AlphaDarkGray60,
    OverlayDark8: Swatches.AlphaDarkGray70,
    OverlayDark9: Swatches.AlphaDarkGray80,
    OverlayDark10: Swatches.AlphaDarkGray90,
    OverlayDark11: Swatches.AlphaDarkGray100,
} as const;

export const MetricsValue = {
    TypographyTypeface: 'Calibre',
    TypographyRegular: 'Regular',
    TypographyMedium: 'Medium',
    TypographySemibold: 'Semibold',
    Typography3xs: 8,
    Typography2xs: 10,
    TypographyXs: 12,
    TypographySm: 14,
    TypographyMs: 16,
    TypographyMd: 18,
    TypographyMl: 20,
    TypographyLg: 24,
    TypographyXl: 28,
    Typography2xl: 32,
    Typography3xl: 40,
    Regular3xs: 2,
    Regular2xs: 4,
    RegularXs: 6,
    RegularSm: 8,
    RegularMs: 12,
    RegularMd: 16,
    RegularMl: 24,
    RegularLg: 32,
    RegularXl: 40,
    Regular2xl: 48,
    Regular3xl: 64,
    Large3xs: 80,
    Large2xs: 96,
    LargeXs: 112,
    LargeSm: 128,
    LargeMs: 144,
    LargeMd: 160,
    LargeMl: 192,
    LargeLg: 224,
    LargeXl: 256,
    Large2xl: 288,
    Large3xl: 320,
    None: 0,
    OneXSm: 8,
    OneXMd: 16,
    OneXXl: 32,
    OneXMl: 20,
    OneX2xs: 4,
    OneX3xs: 2,
    OneXMs: 12,
    OneXLg: 24,
    OneX2xl: 40,
    OneX3xl: 48,
    OneXXs: 6,
    TenX2xs: 80,
    TenXXs: 96,
    TenXSm: 112,
    TenXMs: 128,
    TenX3xs: 64,
    TenXMd: 160,
    TenXMl: 192,
    TenXLg: 224,
    TenXXl: 256,
    TenX2xl: 288,
    TenX3xl: 320,
} as const;

export const TypographyStyles = {
    ShadowSm: {
        color: '#00000029',
        x: 0,
        y: 4,
        blur: 8,
        spread: 0,
    },
    H1: {
        fontFamily: MetricsValue.TypographyTypeface,
        fontWeight: MetricsValue.TypographySemibold,
        lineHeight: 'AUTO',
        fontSize: MetricsValue.Typography3xl,
        letterSpacing: '0%',
        paragraphSpacing: 0,
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none',
    },
    H2: {
        fontFamily: MetricsValue.TypographyTypeface,
        fontWeight: MetricsValue.TypographySemibold,
        lineHeight: 'AUTO',
        fontSize: MetricsValue.Typography2xl,
        letterSpacing: '0%',
        paragraphSpacing: 0,
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none',
    },
    H3: {
        fontFamily: MetricsValue.TypographyTypeface,
        fontWeight: MetricsValue.TypographySemibold,
        lineHeight: 'AUTO',
        fontSize: MetricsValue.TypographyXl,
        letterSpacing: '0%',
        paragraphSpacing: 0,
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none',
    },
    H4: {
        fontFamily: MetricsValue.TypographyTypeface,
        fontWeight: MetricsValue.TypographySemibold,
        lineHeight: 'AUTO',
        fontSize: MetricsValue.TypographyLg,
        letterSpacing: '0%',
        paragraphSpacing: 0,
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none',
    },
    H5: {
        fontFamily: MetricsValue.TypographyTypeface,
        fontWeight: MetricsValue.TypographySemibold,
        lineHeight: 'AUTO',
        fontSize: MetricsValue.TypographyMl,
        letterSpacing: '0%',
        paragraphSpacing: 0,
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none',
    },
    H6: {
        fontFamily: MetricsValue.TypographyTypeface,
        fontWeight: MetricsValue.TypographySemibold,
        lineHeight: 'AUTO',
        fontSize: MetricsValue.TypographyMs,
        letterSpacing: '0%',
        paragraphSpacing: 0,
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none',
    },
    LabelLg: {
        fontFamily: MetricsValue.TypographyTypeface,
        fontWeight: MetricsValue.TypographyMedium,
        lineHeight: 'AUTO',
        fontSize: MetricsValue.TypographyMs,
        letterSpacing: '0%',
        paragraphSpacing: 0,
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none',
    },
    BodyLg: {
        fontFamily: MetricsValue.TypographyTypeface,
        fontWeight: MetricsValue.TypographyRegular,
        lineHeight: 'AUTO',
        fontSize: MetricsValue.TypographyMs,
        letterSpacing: '0%',
        paragraphSpacing: 0,
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none',
    },
    LabelMd: {
        fontFamily: MetricsValue.TypographyTypeface,
        fontWeight: MetricsValue.TypographyMedium,
        lineHeight: 'AUTO',
        fontSize: MetricsValue.TypographySm,
        letterSpacing: '0%',
        paragraphSpacing: 0,
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none',
    },
    BodyMd: {
        fontFamily: MetricsValue.TypographyTypeface,
        fontWeight: MetricsValue.TypographyRegular,
        lineHeight: 'AUTO',
        fontSize: MetricsValue.TypographySm,
        letterSpacing: '0%',
        paragraphSpacing: 0,
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none',
    },
    LabelSm: {
        fontFamily: MetricsValue.TypographyTypeface,
        fontWeight: MetricsValue.TypographyMedium,
        lineHeight: 'AUTO',
        fontSize: MetricsValue.TypographyXs,
        letterSpacing: '0%',
        paragraphSpacing: 0,
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none',
    },
    BodySm: {
        fontFamily: MetricsValue.TypographyTypeface,
        fontWeight: MetricsValue.TypographyRegular,
        lineHeight: 'AUTO',
        fontSize: MetricsValue.TypographyXs,
        letterSpacing: '0%',
        paragraphSpacing: 0,
        paragraphIndent: '0px',
        textCase: 'none',
        textDecoration: 'none',
    },
} as const;

const Colors = {
    sunset500: '#ff7733',
    sunset400: '#ff8a4f',
    sunset300: '#ffaa80',
    sunset200: '#ffcab0',
    sunset100: '#ffeadd',
    sunset75: '#fff3ed',
    sunset50: '#fffbf9',

    b500: '#164dba',
    b400: '#1e57cf',
    b300: '#2e6be6',
    b300_l62: '#5284ea',
    b300_l70: '#769eef',
    b300_l76: '#91b2f2',
    b300_l90: '#d1dffa',
    b300_l96: '#edf2fd',
    b200: '#4888e5',
    b100: '#72b0e8',
    b75: '#acd9ef',
    b50: '#ebf7fa',

    g500: '#033331',
    g400: '#043b38',
    g300: '#064b42',
    g200: '#0f6453',
    g100: '#298c6b',
    g75: '#76bfa0',
    g50: '#e8f7ee',

    p600: '#112d41',
    p600_24: 'rgba(17, 45, 65, 0.24)',
    p600_32: 'rgba(17, 45, 65, 0.32)',
    p600_56: 'rgba(17, 45, 65, 0.56)',
    p500: '#153851',
    p400: '#153b55',
    p300: '#1e4463',
    p200: '#2f5678',
    p100: '#56799a',
    p100_l90: '#dee6ed',
    p75: '#99b0c9',
    p60: '#dbeaff',
    p50: '#f5f9ff',

    n100: '#1d2527',
    n85: '#3f4547',
    n70: '#606667',
    n50: '#8e9293',
    n30: '#bbbdbe',
    n15: '#dddfdf',
    n15_48: 'rgba(221, 223, 223, 0.48)',
    n15_32: 'rgba(221, 223, 223, 0.32)',
    n15_24: 'rgba(221, 223, 223, 0.24)',
    n15_16: 'rgba(221, 223, 223, 0.16)',
    n5: '#f3f4f4',

    nx100: 'rgba(15, 15, 15, 1)',
    nx48: 'rgba(15, 15, 15, 0.48)',
    nx24: 'rgba(15, 15, 15, 0.24)',
    nx16: 'rgba(15, 15, 15, 0.16)',
    nx12: 'rgba(15, 15, 15, 0.12)',
    nx8: 'rgba(15, 15, 15, 0.08)',
    nx4: 'rgba(15, 15, 15, 0.04)',

    amber30: '#ffaa00',
    amber20: '#ec890c',
    amber10: '#fbdfbb',

    subG30: '#3ba542',
    subG20: '#24916d',
    subG10: '#5cd6ad',

    r50: '#e93c3c',
    r40: '#f07575',
    r30: '#f5677c',
    r20: '#f99fad',
    r10: '#fde7e9',

    i20: '#8d9ee7',
    i10: '#c0c9f2',

    subS10: '#ffbb99',

    rose20: '#ba3b79',
    rose10: '#da8bb2',
    rose5: 'rgba(239, 230, 239, 1)',
    rose15: 'rgb(217, 196, 217)',

    purple20: '#5C3D99',
    purple15: '#C9B8F0',
    purple10: '#D8CCFF',
    purple5: '#EDE8FC',

    royalBlue: 'rgba(46, 107, 230, 1)',
    mistyRose: 'rgba(255, 234, 221, 1)',
    blackPearl: 'rgba(29, 37, 39, 1)',
    coral: 'rgba(255, 138, 79, 1)',
    prussianBlue: 'rgba(22, 59, 85, 1)',
    seaGreen: 'rgba(41, 140, 107, 1)',
    platinum: '#e6e7e8',
    ghostWhite: '#fafbfc',
    coolGrey: '#8b9599',
    sidebarBackground: '#F0F3F6',
    sidebarIconColor: '#6D7E94',

    slate300: '#cbd5e1',
    slate400: '#94a3b8',
    slate500: '#64748b',

    white: '#ffffff',
    warning: '#f25d66',
    successful: '#70d4be',
};

const Gradients = {
    r100_r75: 'linear-gradient(to top, #fff3ed, #ffeadd)',
};

const Shadows = {
    border: `0 0 0 1px ${Colors.nx4}`,
    small: `0 8px 12px 0 ${Colors.nx4}`,
    medium: `0 4px 8px 0 ${Colors.nx8}`,
    large: `0 4px 8px 0 ${Colors.nx4}, 0 12px 24px 0 ${Colors.nx16}`,
    xlarge: `0 4px 8px 0 ${Colors.nx8}, 0 16px 32px 0 ${Colors.nx16}`,
};

const Rounded = {
    xsmall: '2px',
    small: '3px',
    medium: '6px',
    large: '12px',
    xlarge: '24px',
};

const Borders = {
    regular: `1px solid ${Colors.nx8}`,
};

const Fonts = {
    calibre:
        '"Calibre", -apple-system, BlinkMacSystemFont, "San Francisco", "Segoe UI", Roboto, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
};

const FontSizes = {
    xxxlarge: '48px',
    xxlarge: '36px',
    xlarge: '28px',
    large: '24px',
    medium: '20px',
    small: '18px',
    xsmall: '16px',
    tiny: '14px',
};

const FontWeight = {
    regular: '400',
    medium: '500',
    semibold: '600',
};

export const Variables = {
    Colors,
    Gradients,
    Shadows,
    Rounded,
    Borders,
    Fonts,
    FontSizes,
    FontWeight,
    Swatches,
    ThemeLight,
    ThemeDark,
    MetricsValue,
    TypographyStyles,

    backgroundColor: `${Colors.ghostWhite}`,
    baseFontSize: '15px',
    fontWeightMedium: '500',
    transition: 'all 0.2s linear',
    sidebarSize: '248px',
    sidebarPadding: '72px',
    topnavSize: '64px',
};
